'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dPeriod from "./presto.types$-Dashboard-Period.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DashboardPeriod$$anon$7(_$ordinal$19, \u03b4name$19, outer) {
  this.cy3 = 0;
  this.a9y = null;
  this.cy3 = _$ordinal$19;
  this.a9y = \u03b4name$19;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$DashboardPeriod$$anon$7 as $c_Lpresto_types$DashboardPeriod$$anon$7 };
$p = $c_Lpresto_types$DashboardPeriod$$anon$7.prototype = new $j_presto$002etypes$0024$002dDashboard$002dPeriod.$h_Lpresto_types$DashboardPeriod();
$p.constructor = $c_Lpresto_types$DashboardPeriod$$anon$7;
/** @constructor */
function $h_Lpresto_types$DashboardPeriod$$anon$7() {
}
export { $h_Lpresto_types$DashboardPeriod$$anon$7 as $h_Lpresto_types$DashboardPeriod$$anon$7 };
$h_Lpresto_types$DashboardPeriod$$anon$7.prototype = $p;
$p.r = (function() {
  return 0;
});
$p.j = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.s = (function() {
  return this.a9y;
});
$p.l = (function() {
  return this.a9y;
});
var $d_Lpresto_types$DashboardPeriod$$anon$7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DashboardPeriod$$anon$7, "presto.types$DashboardPeriod$$anon$7", ({
  Zf: 1,
  Zd: 1,
  b: 1,
  c: 1,
  a: 1,
  q: 1,
  s: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_types$DashboardPeriod$$anon$7 as $d_Lpresto_types$DashboardPeriod$$anon$7 };
//# sourceMappingURL=presto.types$-Dashboard-Period$$anon$7.js.map
